/* jshint esversion: 6 */
import React from 'react';
import { Link } from 'react-router-dom';
import Content from 'app/components/common/Content.jsx';
import AppProvider from 'app/redux/Providers/AppProvider.jsx';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';
import { compose } from 'redux';
import { Breakpoint } from 'react-socks';
import Sidebar from 'app/components/common/SideBar.jsx';

class RouterError extends React.Component {
	render() {
		let logoUrl = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100.png'].join(''),
			logoUrl2X = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100@2x.png'].join(''),
			error = (
	            <div className="app-error clearfix">
	                <div className="error-header-wrapper">
	                    <div className="icon-background">
	                        <i className="icon ion-ios-rainy"></i>
	                    </div>
	                    <div className="copy-wrapper">
	                        <h1>Sorry...</h1>
	                        <p>We don't have a destination for that link</p>
	                    </div>
	                </div>
	                <div className="error-detail-section">
	                    <div className="error-action-section">
							<button role="button" aria-label="Return to the app" className="btn-primary active" onClick={(e) => {
								e.preventDefault();
								this.props.router.navigate("/");
							}}>
								Return to the App
							</button>
	                    </div>
	                </div>
	            </div>
	        );


		return (
			<div>
				<header className="nav-wrapper">
					<div className="nav-container">
						<div className="app-column nav left">
							<div className="logo-wrapper">
								<span className="va-helper"></span>
								<Link to="/share/automate">
									<img
										src={logoUrl}
										srcSet={`${logoUrl} 1x, ${logoUrl2X} 2x`}
										width="31px"
										height="100px"
										className="nav-logo" />
								</Link>
							</div>
						</div>
					</div>
				</header>
				<div className="content-wrapper">
					<div className="content-container">
					<div>
						<Breakpoint desktop only>
							<Sidebar/>
						</Breakpoint>
						<Content main={error}/>
					</div>
					</div>
				</div>
			</div>
		);
	}
};

RouterError.displayName = "Share";

const enhance = compose(
	AppProvider,
	ComponentWithRouter
);

export default enhance(RouterError);
